import React, {useContext} from 'react';

const StaffContext = React.createContext();

export const useStaffContext = () => useContext(StaffContext);

export default StaffContext;
